import { Pipe, PipeTransform } from '@angular/core';

import { PromotionTabItem } from './promotions.models';

@Pipe({
    name: 'filterActiveTab',
    pure: true,
    standalone: true,
})
export class FilterActiveTabPipe implements PipeTransform {
    public transform(tabs: PromotionTabItem[], product: string): PromotionTabItem[] {
        return tabs.filter((t) => {
            return t.id === product;
        });
    }
}
